module.exports = __webpack_public_path__ + "static/Naos-80bab972d4733e4c180393a9b42c62f3.svg";